<template>
  <div class="freight-table-summary">
    <StatusBadge
      v-if="details.status"
      :label="details.status"
      :active="details.statusValor === FREIGHT_TABLE_STATUS.ATIVA"
    />

    <p v-if="modalLabel" class="freight-table-summary__modal">
      {{ modalLabel }}
    </p>

    <h2 class="freight-table-summary__title">{{ title }}</h2>

    <div class="freight-table-summary__card">
      <div
        v-for="field in fields"
        :key="field.label"
        class="freight-table-summary__field"
      >
        <span class="freight-table-summary__label">{{ field.label }}</span>
        <span class="freight-table-summary__value">{{ field.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import StatusBadge from "@/shared/components/StatusBadge.vue";
import { FREIGHT_TABLE_STATUS } from "../../constants/freightTableStatus";

export default {
  name: "FreightTableSummary",
  components: { StatusBadge },
  props: {
    details: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      FREIGHT_TABLE_STATUS,
    };
  },
  computed: {
    modalLabel() {
      return this.details.modal ? `Modal ${this.details.modal.toLowerCase()}` : "";
    },
    title() {
      const codigo = this.details.codigo || "";
      const descricao = this.details.descricao || "";
      return descricao ? `${codigo} - ${descricao}` : String(codigo);
    },
    tipoLabel() {
      return this.details.tipo ? `Tabela ${this.details.tipo.toLowerCase()}` : "-";
    },
    fields() {
      return [
        { label: "Fornecedor", value: this.details.fornecedorNome || "-" },
        { label: "Tipo cálculo", value: this.details.calculo || "-" },
        { label: "Tabela", value: this.details.tabela || "-" },
        { label: "Tipo", value: this.tipoLabel },
        { label: "Composição", value: this.details.composicao || "-" },
      ];
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.freight-table-summary {
  &__modal {
    font-size: 14px;
    color: @color-text-light;
    margin: 8px 0 0 0;
  }

  &__title {
    font-family: @font-primary;
    font-size: 28px;
    font-weight: 700;
    color: @color-text-dark;
    margin: 4px 0 24px 0;
  }

  &__card {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    background-color: @color-bg-subtle;
    border-radius: 8px;
    padding: 20px 24px;
  }

  &__field {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__label {
    font-size: 14px;
    color: @color-text-light;
    margin-bottom: 4px;
  }

  &__value {
    font-size: 16px;
    color: @color-text-dark;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
